// This file is auto-generated by @hey-api/openapi-ts
import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  DeleteV2BillingAccountsByCodeContactsByContactIdData,
  DeleteV2BillingAccountsByCodeContactsByContactIdResponses,
  DeleteV2SubscriptionsBySubscriptionIdBillingAccountData,
  DeleteV2SubscriptionsBySubscriptionIdBillingAccountResponses,
  GetV2BillingAccountsByCodeData,
  GetV2BillingAccountsByCodeHistoryData,
  GetV2BillingAccountsByCodeHistoryResponses,
  GetV2BillingAccountsByCodeHistorySnapshotData,
  GetV2BillingAccountsByCodeHistorySnapshotResponses,
  GetV2BillingAccountsByCodeIntegrationAttemptsData,
  GetV2BillingAccountsByCodeIntegrationAttemptsResponses,
  GetV2BillingAccountsByCodeResponses,
  GetV2BillingAccountsData,
  GetV2BillingAccountsResponses,
  GetV2ConfigurationFeaturesData,
  GetV2ConfigurationFeaturesResponses,
  GetV2CountriesData,
  GetV2CountriesResponses,
  GetV2FulfillmentsByFulfillmentIdData,
  GetV2FulfillmentsByFulfillmentIdHistoryData,
  GetV2FulfillmentsByFulfillmentIdHistoryResponses,
  GetV2FulfillmentsByFulfillmentIdResponses,
  GetV2FulfillmentsData,
  GetV2FulfillmentsResponses,
  GetV2LegalTermsData,
  GetV2LegalTermsResponses,
  GetV2LicensesOctopusCloudByIdData,
  GetV2LicensesOctopusCloudByIdResponses,
  GetV2LicensesOctopusCloudSerialBySerialData,
  GetV2LicensesOctopusCloudSerialBySerialResponses,
  GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdData,
  GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdResponses,
  GetV2LicensesOctopusServerByIdData,
  GetV2LicensesOctopusServerByIdResponses,
  GetV2LicensesOctopusServerSerialBySerialData,
  GetV2LicensesOctopusServerSerialBySerialResponses,
  GetV2LicensesOctopusServerSubscriptionBySubscriptionIdData,
  GetV2LicensesOctopusServerSubscriptionBySubscriptionIdResponses,
  GetV2OrdersByOdNumberContactsData,
  GetV2OrdersByOdNumberContactsResponses,
  GetV2OrdersByOdNumberData,
  GetV2OrdersByOdNumberDocumentData,
  GetV2OrdersByOdNumberDocumentResponses,
  GetV2OrdersByOdNumberFulfillmentData,
  GetV2OrdersByOdNumberFulfillmentResponses,
  GetV2OrdersByOdNumberHistoryData,
  GetV2OrdersByOdNumberHistoryResponses,
  GetV2OrdersByOdNumberRateCardOperationsData,
  GetV2OrdersByOdNumberRateCardOperationsResponses,
  GetV2OrdersByOdNumberResponses,
  GetV2OrdersData,
  GetV2OrdersResellersData,
  GetV2OrdersResellersResponses,
  GetV2OrdersResponses,
  GetV2OrdersSalesRepsData,
  GetV2OrdersSalesRepsResponses,
  GetV2OrdersSearchData,
  GetV2OrdersSearchResponses,
  GetV2PlansByIdData,
  GetV2PlansByIdResponses,
  GetV2PlansData,
  GetV2PlansPlatformByPlatformData,
  GetV2PlansPlatformByPlatformResponses,
  GetV2PlansResponses,
  GetV2RateCardsByCodeData,
  GetV2RateCardsByCodeResponses,
  GetV2RateCardsData,
  GetV2RateCardsResponses,
  GetV2SubscriptionsByIdData,
  GetV2SubscriptionsByIdHistoryData,
  GetV2SubscriptionsByIdHistoryResponses,
  GetV2SubscriptionsByIdHistorySnapshotData,
  GetV2SubscriptionsByIdHistorySnapshotResponses,
  GetV2SubscriptionsByIdLicenseEmailsData,
  GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsData,
  GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsResponses,
  GetV2SubscriptionsByIdLicenseEmailsResponses,
  GetV2SubscriptionsByIdResponses,
  GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewData,
  GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewResponses,
  GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryData,
  GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryResponses,
  GetV2SubscriptionsData,
  GetV2SubscriptionsResponses,
  GetV2SubscriptionsTrialEntitlementsData,
  GetV2SubscriptionsTrialEntitlementsResponses,
  PatchV2SubscriptionsByIdAutoRenewalData,
  PatchV2SubscriptionsByIdAutoRenewalResponses,
  PatchV2SubscriptionsByIdData,
  PatchV2SubscriptionsByIdEntitlementOverridesData,
  PatchV2SubscriptionsByIdEntitlementOverridesResponses,
  PatchV2SubscriptionsByIdPlanData,
  PatchV2SubscriptionsByIdPlanResponses,
  PatchV2SubscriptionsByIdResponses,
  PatchV2SubscriptionsByIdSelfServiceEnabledData,
  PatchV2SubscriptionsByIdSelfServiceEnabledResponses,
  PatchV2SubscriptionsByIdZuoraSubscriptionKeyData,
  PatchV2SubscriptionsByIdZuoraSubscriptionKeyResponses,
  PostV2BillingAccountsByCodeContactsByContactIdRedactData,
  PostV2BillingAccountsByCodeContactsByContactIdRedactResponses,
  PostV2BillingAccountsByCodeContactsData,
  PostV2BillingAccountsByCodeContactsResponses,
  PostV2BillingAccountsByCodePushToBillingSystemData,
  PostV2BillingAccountsByCodePushToBillingSystemResponses,
  PostV2BillingAccountsData,
  PostV2BillingAccountsResponses,
  PostV2OrdersByOdNumberAcceptData,
  PostV2OrdersByOdNumberAcceptResponses,
  PostV2OrdersByOdNumberArchiveData,
  PostV2OrdersByOdNumberArchiveResponses,
  PostV2OrdersByOdNumberCancelData,
  PostV2OrdersByOdNumberCancelResponses,
  PostV2OrdersByOdNumberMakeLiveData,
  PostV2OrdersByOdNumberMakeLiveResponses,
  PostV2OrdersByOdNumberPricePreviewData,
  PostV2OrdersByOdNumberPricePreviewResponses,
  PostV2OrdersByOdNumberRateCardCloneData,
  PostV2OrdersByOdNumberRateCardCloneResponses,
  PostV2OrdersByOdNumberRateCardPlanDefaultData,
  PostV2OrdersByOdNumberRateCardPlanDefaultResponses,
  PostV2OrdersByOdNumberReopenData,
  PostV2OrdersByOdNumberReopenResponses,
  PostV2OrdersByOdNumberRetractData,
  PostV2OrdersByOdNumberRetractResponses,
  PostV2OrdersByOdNumberTaxEstimateData,
  PostV2OrdersByOdNumberTaxEstimateResponses,
  PostV2OrdersData,
  PostV2OrdersResponses,
  PostV2RateCardsBulkAssignData,
  PostV2RateCardsBulkAssignResponses,
  PostV2RateCardsData,
  PostV2RateCardsPreviewData,
  PostV2RateCardsPreviewResponses,
  PostV2RateCardsResponses,
  PostV2SubscriptionsByIdCancelData,
  PostV2SubscriptionsByIdCancelResponses,
  PostV2SubscriptionsByIdDowngradeToFreeData,
  PostV2SubscriptionsByIdDowngradeToFreeResponses,
  PostV2SubscriptionsByIdExtendTermData,
  PostV2SubscriptionsByIdExtendTermResponses,
  PostV2SubscriptionsByIdLicenseEmailsData,
  PostV2SubscriptionsByIdLicenseEmailsResponses,
  PostV2SubscriptionsByIdReactivateData,
  PostV2SubscriptionsByIdReactivateResponses,
  PostV2SubscriptionsByIdTransitionToComplimentaryData,
  PostV2SubscriptionsByIdTransitionToComplimentaryResponses,
  PostV2SubscriptionsByIdTransitionToEvergreenData,
  PostV2SubscriptionsByIdTransitionToEvergreenResponses,
  PostV2SubscriptionsByIdTransitionToPaidData,
  PostV2SubscriptionsByIdTransitionToPaidResponses,
  PostV2SubscriptionsByIdTransitionToTrialData,
  PostV2SubscriptionsByIdTransitionToTrialResponses,
  PostV2SubscriptionsBySubscriptionIdBillingAccountData,
  PostV2SubscriptionsBySubscriptionIdBillingAccountResponses,
  PostV2SubscriptionsBySubscriptionIdRateCardCalculateData,
  PostV2SubscriptionsBySubscriptionIdRateCardCalculateResponses,
  PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateData,
  PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateResponses,
  PostV2SubscriptionsBySubscriptionIdRateCardDraftsData,
  PostV2SubscriptionsBySubscriptionIdRateCardDraftsResponses,
  PostV2SubscriptionsData,
  PostV2SubscriptionsResponses,
  PutV2BillingAccountsByCodeContactsByContactIdData,
  PutV2BillingAccountsByCodeContactsByContactIdResponses,
  PutV2BillingAccountsByCodeData,
  PutV2BillingAccountsByCodeResponses,
  PutV2OrdersByOdNumberData,
  PutV2OrdersByOdNumberInternalConfirmationData,
  PutV2OrdersByOdNumberInternalConfirmationResponses,
  PutV2OrdersByOdNumberResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

class HeyApiClient {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new BillingAccountsApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient2 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry2<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new ConfigurationApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient3 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry3<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new CountriesApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient4 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry4<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new FulfillmentsApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient5 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry5<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new LegalTermsApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient6 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry6<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new LicensesApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient7 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry7<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new OrdersApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient8 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry8<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new OrderTaxEstimatesApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient9 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry9<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new PlansApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient10 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry10<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new RateCardsApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient11 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry11<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new SubscriptionBillingAccountApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient12 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry12<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new SubscriptionRateCardsApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

class HeyApiClient13 {
  protected client: Client;

  constructor(args?: { client?: Client }) {
    this.client = args?.client ?? client;
  }
}

class HeyApiRegistry13<T> {
  private readonly defaultKey = "default";

  private readonly instances: Map<string, T> = new Map();

  get(key?: string): T {
    const instance = this.instances.get(key ?? this.defaultKey);
    if (!instance) {
      throw new Error(`No SDK client found. Create one with "new SubscriptionsApi()" to fix this error.`);
    }
    return instance;
  }

  set(value: T, key?: string): void {
    this.instances.set(key ?? this.defaultKey, value);
  }
}

export class BillingAccountsApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry<BillingAccountsApi> = new HeyApiRegistry<BillingAccountsApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    BillingAccountsApi.__registry.set(this, args?.key);
  }

  public getV2BillingAccounts<ThrowOnError extends boolean = true>(
    options?: Options<GetV2BillingAccountsData, ThrowOnError>
  ): RequestResult<GetV2BillingAccountsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2BillingAccountsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts",
      ...options,
    });
  }

  public postV2BillingAccounts<ThrowOnError extends boolean = true>(
    options?: Options<PostV2BillingAccountsData, ThrowOnError>
  ): RequestResult<PostV2BillingAccountsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).post<PostV2BillingAccountsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  public getV2BillingAccountsByCode<ThrowOnError extends boolean = true>(
    options: Options<GetV2BillingAccountsByCodeData, ThrowOnError>
  ): RequestResult<GetV2BillingAccountsByCodeResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2BillingAccountsByCodeResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}",
      ...options,
    });
  }

  public putV2BillingAccountsByCode<ThrowOnError extends boolean = true>(
    options: Options<PutV2BillingAccountsByCodeData, ThrowOnError>
  ): RequestResult<PutV2BillingAccountsByCodeResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).put<PutV2BillingAccountsByCodeResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public getV2BillingAccountsByCodeHistory<ThrowOnError extends boolean = true>(
    options: Options<GetV2BillingAccountsByCodeHistoryData, ThrowOnError>
  ): RequestResult<GetV2BillingAccountsByCodeHistoryResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2BillingAccountsByCodeHistoryResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/history",
      ...options,
    });
  }

  public getV2BillingAccountsByCodeHistorySnapshot<ThrowOnError extends boolean = true>(
    options: Options<GetV2BillingAccountsByCodeHistorySnapshotData, ThrowOnError>
  ): RequestResult<GetV2BillingAccountsByCodeHistorySnapshotResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2BillingAccountsByCodeHistorySnapshotResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/history-snapshot",
      ...options,
    });
  }

  public postV2BillingAccountsByCodeContacts<ThrowOnError extends boolean = true>(
    options: Options<PostV2BillingAccountsByCodeContactsData, ThrowOnError>
  ): RequestResult<PostV2BillingAccountsByCodeContactsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2BillingAccountsByCodeContactsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/contacts",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2BillingAccountsByCodePushToBillingSystem<ThrowOnError extends boolean = true>(
    options: Options<PostV2BillingAccountsByCodePushToBillingSystemData, ThrowOnError>
  ): RequestResult<PostV2BillingAccountsByCodePushToBillingSystemResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2BillingAccountsByCodePushToBillingSystemResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/push-to-billing-system",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public getV2BillingAccountsByCodeIntegrationAttempts<ThrowOnError extends boolean = true>(
    options: Options<GetV2BillingAccountsByCodeIntegrationAttemptsData, ThrowOnError>
  ): RequestResult<GetV2BillingAccountsByCodeIntegrationAttemptsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2BillingAccountsByCodeIntegrationAttemptsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/integration-attempts",
      ...options,
    });
  }

  public deleteV2BillingAccountsByCodeContactsByContactId<ThrowOnError extends boolean = true>(
    options: Options<DeleteV2BillingAccountsByCodeContactsByContactIdData, ThrowOnError>
  ): RequestResult<DeleteV2BillingAccountsByCodeContactsByContactIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).delete<
      DeleteV2BillingAccountsByCodeContactsByContactIdResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/contacts/{contactId}",
      ...options,
    });
  }

  public putV2BillingAccountsByCodeContactsByContactId<ThrowOnError extends boolean = true>(
    options: Options<PutV2BillingAccountsByCodeContactsByContactIdData, ThrowOnError>
  ): RequestResult<PutV2BillingAccountsByCodeContactsByContactIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).put<
      PutV2BillingAccountsByCodeContactsByContactIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/contacts/{contactId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2BillingAccountsByCodeContactsByContactIdRedact<ThrowOnError extends boolean = true>(
    options: Options<PostV2BillingAccountsByCodeContactsByContactIdRedactData, ThrowOnError>
  ): RequestResult<PostV2BillingAccountsByCodeContactsByContactIdRedactResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2BillingAccountsByCodeContactsByContactIdRedactResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/billing-accounts/{code}/contacts/{contactId}/redact",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class ConfigurationApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry2<ConfigurationApi> = new HeyApiRegistry2<ConfigurationApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    ConfigurationApi.__registry.set(this, args?.key);
  }

  public getV2ConfigurationFeatures<ThrowOnError extends boolean = true>(
    options?: Options<GetV2ConfigurationFeaturesData, ThrowOnError>
  ): RequestResult<GetV2ConfigurationFeaturesResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2ConfigurationFeaturesResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/configuration/features",
      ...options,
    });
  }
}

export class CountriesApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry3<CountriesApi> = new HeyApiRegistry3<CountriesApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    CountriesApi.__registry.set(this, args?.key);
  }

  public getV2Countries<ThrowOnError extends boolean = true>(
    options?: Options<GetV2CountriesData, ThrowOnError>
  ): RequestResult<GetV2CountriesResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2CountriesResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/countries",
      ...options,
    });
  }
}

export class FulfillmentsApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry4<FulfillmentsApi> = new HeyApiRegistry4<FulfillmentsApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    FulfillmentsApi.__registry.set(this, args?.key);
  }

  public getV2Fulfillments<ThrowOnError extends boolean = true>(
    options: Options<GetV2FulfillmentsData, ThrowOnError>
  ): RequestResult<GetV2FulfillmentsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2FulfillmentsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/fulfillments",
      ...options,
    });
  }

  public getV2FulfillmentsByFulfillmentId<ThrowOnError extends boolean = true>(
    options: Options<GetV2FulfillmentsByFulfillmentIdData, ThrowOnError>
  ): RequestResult<GetV2FulfillmentsByFulfillmentIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2FulfillmentsByFulfillmentIdResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/fulfillments/{fulfillmentId}",
      ...options,
    });
  }

  public getV2FulfillmentsByFulfillmentIdHistory<ThrowOnError extends boolean = true>(
    options: Options<GetV2FulfillmentsByFulfillmentIdHistoryData, ThrowOnError>
  ): RequestResult<GetV2FulfillmentsByFulfillmentIdHistoryResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2FulfillmentsByFulfillmentIdHistoryResponses, unknown, ThrowOnError>(
      {
        responseType: "json",
        security: [{ scheme: "bearer", type: "http" }],
        url: "/v2/fulfillments/{fulfillmentId}/history",
        ...options,
      }
    );
  }
}

export class LegalTermsApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry5<LegalTermsApi> = new HeyApiRegistry5<LegalTermsApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    LegalTermsApi.__registry.set(this, args?.key);
  }

  public getV2LegalTerms<ThrowOnError extends boolean = true>(
    options?: Options<GetV2LegalTermsData, ThrowOnError>
  ): RequestResult<GetV2LegalTermsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2LegalTermsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/legal-terms",
      ...options,
    });
  }
}

export class LicensesApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry6<LicensesApi> = new HeyApiRegistry6<LicensesApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    LicensesApi.__registry.set(this, args?.key);
  }

  public getV2LicensesOctopusCloudById<ThrowOnError extends boolean = true>(
    options: Options<GetV2LicensesOctopusCloudByIdData, ThrowOnError>
  ): RequestResult<GetV2LicensesOctopusCloudByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2LicensesOctopusCloudByIdResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/licenses/OctopusCloud/{id}",
      ...options,
    });
  }

  public getV2LicensesOctopusCloudSubscriptionBySubscriptionId<ThrowOnError extends boolean = true>(
    options: Options<GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdData, ThrowOnError>
  ): RequestResult<GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2LicensesOctopusCloudSubscriptionBySubscriptionIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/licenses/OctopusCloud/subscription/{subscriptionId}",
      ...options,
    });
  }

  public getV2LicensesOctopusCloudSerialBySerial<ThrowOnError extends boolean = true>(
    options: Options<GetV2LicensesOctopusCloudSerialBySerialData, ThrowOnError>
  ): RequestResult<GetV2LicensesOctopusCloudSerialBySerialResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2LicensesOctopusCloudSerialBySerialResponses, unknown, ThrowOnError>(
      {
        responseType: "json",
        security: [{ scheme: "bearer", type: "http" }],
        url: "/v2/licenses/OctopusCloud/serial/{serial}",
        ...options,
      }
    );
  }

  public getV2LicensesOctopusServerById<ThrowOnError extends boolean = true>(
    options: Options<GetV2LicensesOctopusServerByIdData, ThrowOnError>
  ): RequestResult<GetV2LicensesOctopusServerByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2LicensesOctopusServerByIdResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/licenses/OctopusServer/{id}",
      ...options,
    });
  }

  public getV2LicensesOctopusServerSubscriptionBySubscriptionId<ThrowOnError extends boolean = true>(
    options: Options<GetV2LicensesOctopusServerSubscriptionBySubscriptionIdData, ThrowOnError>
  ): RequestResult<GetV2LicensesOctopusServerSubscriptionBySubscriptionIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2LicensesOctopusServerSubscriptionBySubscriptionIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/licenses/OctopusServer/subscription/{subscriptionId}",
      ...options,
    });
  }

  public getV2LicensesOctopusServerSerialBySerial<ThrowOnError extends boolean = true>(
    options: Options<GetV2LicensesOctopusServerSerialBySerialData, ThrowOnError>
  ): RequestResult<GetV2LicensesOctopusServerSerialBySerialResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2LicensesOctopusServerSerialBySerialResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/licenses/OctopusServer/serial/{serial}",
      ...options,
    });
  }
}

export class OrdersApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry7<OrdersApi> = new HeyApiRegistry7<OrdersApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    OrdersApi.__registry.set(this, args?.key);
  }

  public getV2Orders<ThrowOnError extends boolean = true>(
    options?: Options<GetV2OrdersData, ThrowOnError>
  ): RequestResult<GetV2OrdersResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2OrdersResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders",
      ...options,
    });
  }

  public postV2Orders<ThrowOnError extends boolean = true>(
    options?: Options<PostV2OrdersData, ThrowOnError>
  ): RequestResult<PostV2OrdersResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).post<PostV2OrdersResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  public getV2OrdersSearch<ThrowOnError extends boolean = true>(
    options: Options<GetV2OrdersSearchData, ThrowOnError>
  ): RequestResult<GetV2OrdersSearchResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2OrdersSearchResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/search",
      ...options,
    });
  }

  public getV2OrdersSalesReps<ThrowOnError extends boolean = true>(
    options?: Options<GetV2OrdersSalesRepsData, ThrowOnError>
  ): RequestResult<GetV2OrdersSalesRepsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2OrdersSalesRepsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/sales-reps",
      ...options,
    });
  }

  public getV2OrdersResellers<ThrowOnError extends boolean = true>(
    options?: Options<GetV2OrdersResellersData, ThrowOnError>
  ): RequestResult<GetV2OrdersResellersResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2OrdersResellersResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/resellers",
      ...options,
    });
  }

  public getV2OrdersByOdNumber<ThrowOnError extends boolean = true>(
    options: Options<GetV2OrdersByOdNumberData, ThrowOnError>
  ): RequestResult<GetV2OrdersByOdNumberResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2OrdersByOdNumberResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}",
      ...options,
    });
  }

  public putV2OrdersByOdNumber<ThrowOnError extends boolean = true>(
    options: Options<PutV2OrdersByOdNumberData, ThrowOnError>
  ): RequestResult<PutV2OrdersByOdNumberResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).put<PutV2OrdersByOdNumberResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public getV2OrdersByOdNumberDocument<ThrowOnError extends boolean = true>(
    options: Options<GetV2OrdersByOdNumberDocumentData, ThrowOnError>
  ): RequestResult<GetV2OrdersByOdNumberDocumentResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2OrdersByOdNumberDocumentResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/document",
      ...options,
    });
  }

  public getV2OrdersByOdNumberHistory<ThrowOnError extends boolean = true>(
    options: Options<GetV2OrdersByOdNumberHistoryData, ThrowOnError>
  ): RequestResult<GetV2OrdersByOdNumberHistoryResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2OrdersByOdNumberHistoryResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/history",
      ...options,
    });
  }

  public getV2OrdersByOdNumberContacts<ThrowOnError extends boolean = true>(
    options: Options<GetV2OrdersByOdNumberContactsData, ThrowOnError>
  ): RequestResult<GetV2OrdersByOdNumberContactsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2OrdersByOdNumberContactsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/contacts",
      ...options,
    });
  }

  public getV2OrdersByOdNumberFulfillment<ThrowOnError extends boolean = true>(
    options: Options<GetV2OrdersByOdNumberFulfillmentData, ThrowOnError>
  ): RequestResult<GetV2OrdersByOdNumberFulfillmentResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2OrdersByOdNumberFulfillmentResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/fulfillment",
      ...options,
    });
  }

  public getV2OrdersByOdNumberRateCardOperations<ThrowOnError extends boolean = true>(
    options: Options<GetV2OrdersByOdNumberRateCardOperationsData, ThrowOnError>
  ): RequestResult<GetV2OrdersByOdNumberRateCardOperationsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2OrdersByOdNumberRateCardOperationsResponses, unknown, ThrowOnError>(
      {
        responseType: "json",
        security: [{ scheme: "bearer", type: "http" }],
        url: "/v2/orders/{odNumber}/rate-card-operations",
        ...options,
      }
    );
  }

  public postV2OrdersByOdNumberPricePreview<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberPricePreviewData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberPricePreviewResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberPricePreviewResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/price-preview",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2OrdersByOdNumberRateCardClone<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberRateCardCloneData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberRateCardCloneResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberRateCardCloneResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/rate-card/clone",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2OrdersByOdNumberRateCardPlanDefault<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberRateCardPlanDefaultData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberRateCardPlanDefaultResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2OrdersByOdNumberRateCardPlanDefaultResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/rate-card/plan-default",
      ...options,
    });
  }

  public postV2OrdersByOdNumberMakeLive<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberMakeLiveData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberMakeLiveResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberMakeLiveResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/make-live",
      ...options,
    });
  }

  public postV2OrdersByOdNumberRetract<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberRetractData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberRetractResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberRetractResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/retract",
      ...options,
    });
  }

  public postV2OrdersByOdNumberCancel<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberCancelData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberCancelResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberCancelResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/cancel",
      ...options,
    });
  }

  public postV2OrdersByOdNumberReopen<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberReopenData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberReopenResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberReopenResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/reopen",
      ...options,
    });
  }

  public postV2OrdersByOdNumberArchive<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberArchiveData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberArchiveResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberArchiveResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/archive",
      ...options,
    });
  }

  public postV2OrdersByOdNumberAccept<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberAcceptData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberAcceptResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberAcceptResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/accept",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public putV2OrdersByOdNumberInternalConfirmation<ThrowOnError extends boolean = true>(
    options: Options<PutV2OrdersByOdNumberInternalConfirmationData, ThrowOnError>
  ): RequestResult<PutV2OrdersByOdNumberInternalConfirmationResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).put<
      PutV2OrdersByOdNumberInternalConfirmationResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/internal-confirmation",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class OrderTaxEstimatesApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry8<OrderTaxEstimatesApi> =
    new HeyApiRegistry8<OrderTaxEstimatesApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    OrderTaxEstimatesApi.__registry.set(this, args?.key);
  }

  public postV2OrdersByOdNumberTaxEstimate<ThrowOnError extends boolean = true>(
    options: Options<PostV2OrdersByOdNumberTaxEstimateData, ThrowOnError>
  ): RequestResult<PostV2OrdersByOdNumberTaxEstimateResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2OrdersByOdNumberTaxEstimateResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/orders/{odNumber}/tax-estimate",
      ...options,
    });
  }
}

export class PlansApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry9<PlansApi> = new HeyApiRegistry9<PlansApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    PlansApi.__registry.set(this, args?.key);
  }

  public getV2Plans<ThrowOnError extends boolean = true>(
    options?: Options<GetV2PlansData, ThrowOnError>
  ): RequestResult<GetV2PlansResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2PlansResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/plans",
      ...options,
    });
  }

  public getV2PlansById<ThrowOnError extends boolean = true>(
    options: Options<GetV2PlansByIdData, ThrowOnError>
  ): RequestResult<GetV2PlansByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2PlansByIdResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/plans/{id}",
      ...options,
    });
  }

  public getV2PlansPlatformByPlatform<ThrowOnError extends boolean = true>(
    options: Options<GetV2PlansPlatformByPlatformData, ThrowOnError>
  ): RequestResult<GetV2PlansPlatformByPlatformResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2PlansPlatformByPlatformResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/plans/platform/{platform}",
      ...options,
    });
  }
}

export class RateCardsApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry10<RateCardsApi> = new HeyApiRegistry10<RateCardsApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    RateCardsApi.__registry.set(this, args?.key);
  }

  public getV2RateCards<ThrowOnError extends boolean = true>(
    options?: Options<GetV2RateCardsData, ThrowOnError>
  ): RequestResult<GetV2RateCardsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2RateCardsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/rate-cards",
      ...options,
    });
  }

  public postV2RateCards<ThrowOnError extends boolean = true>(
    options?: Options<PostV2RateCardsData, ThrowOnError>
  ): RequestResult<PostV2RateCardsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).post<PostV2RateCardsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/rate-cards",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  public getV2RateCardsByCode<ThrowOnError extends boolean = true>(
    options: Options<GetV2RateCardsByCodeData, ThrowOnError>
  ): RequestResult<GetV2RateCardsByCodeResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2RateCardsByCodeResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/rate-cards/{code}",
      ...options,
    });
  }

  public postV2RateCardsBulkAssign<ThrowOnError extends boolean = true>(
    options?: Options<PostV2RateCardsBulkAssignData, ThrowOnError>
  ): RequestResult<PostV2RateCardsBulkAssignResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).post<PostV2RateCardsBulkAssignResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/rate-cards/bulk-assign",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  public postV2RateCardsPreview<ThrowOnError extends boolean = true>(
    options?: Options<PostV2RateCardsPreviewData, ThrowOnError>
  ): RequestResult<PostV2RateCardsPreviewResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).post<PostV2RateCardsPreviewResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/rate-cards/preview",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }
}

export class SubscriptionBillingAccountApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry11<SubscriptionBillingAccountApi> =
    new HeyApiRegistry11<SubscriptionBillingAccountApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    SubscriptionBillingAccountApi.__registry.set(this, args?.key);
  }

  public deleteV2SubscriptionsBySubscriptionIdBillingAccount<ThrowOnError extends boolean = true>(
    options: Options<DeleteV2SubscriptionsBySubscriptionIdBillingAccountData, ThrowOnError>
  ): RequestResult<DeleteV2SubscriptionsBySubscriptionIdBillingAccountResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).delete<
      DeleteV2SubscriptionsBySubscriptionIdBillingAccountResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{subscriptionId}/billing-account",
      ...options,
    });
  }

  public postV2SubscriptionsBySubscriptionIdBillingAccount<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsBySubscriptionIdBillingAccountData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsBySubscriptionIdBillingAccountResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsBySubscriptionIdBillingAccountResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{subscriptionId}/billing-account",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public getV2SubscriptionsBySubscriptionIdBillingAccountTransferPreview<ThrowOnError extends boolean = true>(
    options: Options<GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2SubscriptionsBySubscriptionIdBillingAccountTransferPreviewResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{subscriptionId}/billing-account/transfer-preview",
      ...options,
    });
  }
}

export class SubscriptionRateCardsApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry12<SubscriptionRateCardsApi> =
    new HeyApiRegistry12<SubscriptionRateCardsApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    SubscriptionRateCardsApi.__registry.set(this, args?.key);
  }

  public postV2SubscriptionsBySubscriptionIdRateCardDrafts<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsBySubscriptionIdRateCardDraftsData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsBySubscriptionIdRateCardDraftsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsBySubscriptionIdRateCardDraftsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{subscriptionId}/rate-card-drafts",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivate<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateData, ThrowOnError>
  ): RequestResult<
    PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateResponses,
    unknown,
    ThrowOnError
  > {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{subscriptionId}/rate-card-drafts/{assignmentId}/activate",
      ...options,
    });
  }

  public getV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistory<ThrowOnError extends boolean = true>(
    options: Options<GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2SubscriptionsBySubscriptionIdRateCardAssignmentsHistoryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{subscriptionId}/rate-card-assignments/history",
      ...options,
    });
  }

  public postV2SubscriptionsBySubscriptionIdRateCardCalculate<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsBySubscriptionIdRateCardCalculateData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsBySubscriptionIdRateCardCalculateResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsBySubscriptionIdRateCardCalculateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{subscriptionId}/rate-card/calculate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }
}

export class SubscriptionsApi extends HeyApiClient {
  public static readonly __registry: HeyApiRegistry13<SubscriptionsApi> = new HeyApiRegistry13<SubscriptionsApi>();

  constructor(args?: { client?: Client; key?: string }) {
    super(args);
    SubscriptionsApi.__registry.set(this, args?.key);
  }

  public getV2Subscriptions<ThrowOnError extends boolean = true>(
    options?: Options<GetV2SubscriptionsData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2SubscriptionsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions",
      ...options,
    });
  }

  public postV2Subscriptions<ThrowOnError extends boolean = true>(
    options?: Options<PostV2SubscriptionsData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).post<PostV2SubscriptionsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    });
  }

  public getV2SubscriptionsById<ThrowOnError extends boolean = true>(
    options: Options<GetV2SubscriptionsByIdData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2SubscriptionsByIdResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}",
      ...options,
    });
  }

  public patchV2SubscriptionsById<ThrowOnError extends boolean = true>(
    options: Options<PatchV2SubscriptionsByIdData, ThrowOnError>
  ): RequestResult<PatchV2SubscriptionsByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).patch<PatchV2SubscriptionsByIdResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public getV2SubscriptionsByIdHistorySnapshot<ThrowOnError extends boolean = true>(
    options: Options<GetV2SubscriptionsByIdHistorySnapshotData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsByIdHistorySnapshotResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2SubscriptionsByIdHistorySnapshotResponses, unknown, ThrowOnError>({
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/history-snapshot",
      ...options,
    });
  }

  public patchV2SubscriptionsByIdSelfServiceEnabled<ThrowOnError extends boolean = true>(
    options: Options<PatchV2SubscriptionsByIdSelfServiceEnabledData, ThrowOnError>
  ): RequestResult<PatchV2SubscriptionsByIdSelfServiceEnabledResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).patch<
      PatchV2SubscriptionsByIdSelfServiceEnabledResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/self-service-enabled",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public patchV2SubscriptionsByIdEntitlementOverrides<ThrowOnError extends boolean = true>(
    options: Options<PatchV2SubscriptionsByIdEntitlementOverridesData, ThrowOnError>
  ): RequestResult<PatchV2SubscriptionsByIdEntitlementOverridesResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).patch<
      PatchV2SubscriptionsByIdEntitlementOverridesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/entitlement-overrides",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public patchV2SubscriptionsByIdAutoRenewal<ThrowOnError extends boolean = true>(
    options: Options<PatchV2SubscriptionsByIdAutoRenewalData, ThrowOnError>
  ): RequestResult<PatchV2SubscriptionsByIdAutoRenewalResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).patch<PatchV2SubscriptionsByIdAutoRenewalResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/auto-renewal",
      ...options,
    });
  }

  public patchV2SubscriptionsByIdZuoraSubscriptionKey<ThrowOnError extends boolean = true>(
    options: Options<PatchV2SubscriptionsByIdZuoraSubscriptionKeyData, ThrowOnError>
  ): RequestResult<PatchV2SubscriptionsByIdZuoraSubscriptionKeyResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).patch<
      PatchV2SubscriptionsByIdZuoraSubscriptionKeyResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/zuora-subscription-key",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public patchV2SubscriptionsByIdPlan<ThrowOnError extends boolean = true>(
    options: Options<PatchV2SubscriptionsByIdPlanData, ThrowOnError>
  ): RequestResult<PatchV2SubscriptionsByIdPlanResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).patch<PatchV2SubscriptionsByIdPlanResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/plan",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdCancel<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdCancelData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdCancelResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2SubscriptionsByIdCancelResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/cancel",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdReactivate<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdReactivateData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdReactivateResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2SubscriptionsByIdReactivateResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/reactivate",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdExtendTerm<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdExtendTermData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdExtendTermResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2SubscriptionsByIdExtendTermResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/extend-term",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdTransitionToComplimentary<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdTransitionToComplimentaryData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdTransitionToComplimentaryResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsByIdTransitionToComplimentaryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/transition-to-complimentary",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdTransitionToPaid<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdTransitionToPaidData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdTransitionToPaidResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsByIdTransitionToPaidResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/transition-to-paid",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdTransitionToTrial<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdTransitionToTrialData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdTransitionToTrialResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsByIdTransitionToTrialResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/transition-to-trial",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdTransitionToEvergreen<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdTransitionToEvergreenData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdTransitionToEvergreenResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<
      PostV2SubscriptionsByIdTransitionToEvergreenResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/transition-to-evergreen",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public postV2SubscriptionsByIdDowngradeToFree<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdDowngradeToFreeData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdDowngradeToFreeResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2SubscriptionsByIdDowngradeToFreeResponses, unknown, ThrowOnError>(
      {
        responseType: "json",
        security: [{ scheme: "bearer", type: "http" }],
        url: "/v2/subscriptions/{id}/downgrade-to-free",
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
      }
    );
  }

  public getV2SubscriptionsTrialEntitlements<ThrowOnError extends boolean = true>(
    options?: Options<GetV2SubscriptionsTrialEntitlementsData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsTrialEntitlementsResponses, unknown, ThrowOnError> {
    return (options?.client ?? this.client).get<GetV2SubscriptionsTrialEntitlementsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/trial-entitlements",
      ...options,
    });
  }

  public getV2SubscriptionsByIdHistory<ThrowOnError extends boolean = true>(
    options: Options<GetV2SubscriptionsByIdHistoryData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsByIdHistoryResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2SubscriptionsByIdHistoryResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/history",
      ...options,
    });
  }

  public getV2SubscriptionsByIdLicenseEmails<ThrowOnError extends boolean = true>(
    options: Options<GetV2SubscriptionsByIdLicenseEmailsData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsByIdLicenseEmailsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<GetV2SubscriptionsByIdLicenseEmailsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/license-emails",
      ...options,
    });
  }

  public postV2SubscriptionsByIdLicenseEmails<ThrowOnError extends boolean = true>(
    options: Options<PostV2SubscriptionsByIdLicenseEmailsData, ThrowOnError>
  ): RequestResult<PostV2SubscriptionsByIdLicenseEmailsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).post<PostV2SubscriptionsByIdLicenseEmailsResponses, unknown, ThrowOnError>({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/license-emails",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });
  }

  public getV2SubscriptionsByIdLicenseEmailsDefaultRecipients<ThrowOnError extends boolean = true>(
    options: Options<GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsData, ThrowOnError>
  ): RequestResult<GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsResponses, unknown, ThrowOnError> {
    return (options.client ?? this.client).get<
      GetV2SubscriptionsByIdLicenseEmailsDefaultRecipientsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v2/subscriptions/{id}/license-emails/default-recipients",
      ...options,
    });
  }
}
